import { Component } from '@angular/core';
import { LanguageService } from '../../../core/i18n/language.service';
import { AppLanguage } from '../../../core/i18n/language.types';
import { TranslatePipe } from '../../../core/i18n/translate.pipe';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {
  readonly lang;

  constructor(private readonly i18n: LanguageService) {
    this.lang = this.i18n.lang;
  }

  setLang(lang: AppLanguage): void {
    this.i18n.setLanguage(lang);
  }
}
